import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useTeleportsStore = defineStore('booking-wizard/teleports', () => {
    // State
    const teleportHosts = ref<{ [key: string]: HTMLElement | undefined }>({});

    // Getters
    const getTeleportHost = computed(() => {
        return (key: string) => teleportHosts.value[key];
    });

    const teleportHostReady = computed(() => {
        return (key: string) => teleportHosts.value[key] !== undefined;
    });

    // Actions
    const updateTeleportHost = (key: string, host: HTMLElement) => {
        teleportHosts.value[key] = host;
    };

    return {
        // State
        teleportHosts,

        // Getters
        getTeleportHost,
        teleportHostReady,

        // Actions
        updateTeleportHost,
    };
});
